module.exports = {"510112001":"龙泉街道","510112002":"大面街道","510112003":"十陵街道","510112004":"同安街道","510112005":"西河街道","510112006":"柏合街道","510112007":"东安街道","510112102":"洛带镇","510112108":"洪安镇","510112115":"山泉镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510112.json
// module id = 2387
// module chunks = 0